import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorAnnouncement = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M9 7.25a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V8A.75.75 0 0 1 9 7.25Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M21.75 5.94c0-1.94-1.955-3.27-3.76-2.558L9.08 6.9a1.25 1.25 0 0 1-.46.087H5a2.75 2.75 0 0 0-2.75 2.75v4.526c0 1.19.755 2.203 1.812 2.586l.822 2.945a2.676 2.676 0 0 0 5.156-1.44l-.275-.982 8.225 3.246c1.805.713 3.76-.617 3.76-2.558V5.94ZM8.108 17.013H5.665l.664 2.377a1.176 1.176 0 0 0 2.266-.633l-.487-1.744ZM18.54 4.777A1.25 1.25 0 0 1 20.25 5.94v12.12a1.25 1.25 0 0 1-1.709 1.163l-8.912-3.518a2.748 2.748 0 0 0-1.01-.192H5c-.69 0-1.25-.56-1.25-1.25V9.737c0-.69.56-1.25 1.25-1.25h3.62a2.75 2.75 0 0 0 1.01-.192l8.911-3.518Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorAnnouncement;
